// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'spellcheck';

export const Component = () => (
  <path d='m23.695 8.316-.67-.67-12.787 12.74-6.849-6.85-.67.671 7.52 7.567L23.695 8.316ZM5.256 6.927l.67 1.964h.958L4.921 3h-.958L2 8.89h.958l.622-1.963h1.677Zm-.335-1.005h-.958l.48-1.628.478 1.628ZM16.702 8.89V7.885h-2.92V3.958h2.92V3H14.26c-.431 0-.766.144-1.054.431a1.408 1.408 0 0 0-.431 1.054v2.921c0 .432.144.767.431 1.054.288.288.623.431 1.054.431h2.442Zm-4.885-4.406c0-.431-.144-.766-.431-1.054A1.408 1.408 0 0 0 10.332 3H7.89v5.89h2.442a1.41 1.41 0 0 0 1.054-.43c.287-.288.431-.623.431-1.055v-.957c0-.336-.144-.67-.383-1.006.24-.239.383-.575.383-.958v.001Zm-1.005 1.437v1.964H8.848V5.921h1.964Zm0-1.964v1.006H8.848V3.957h1.964Z' />
);

export const viewBox = '0 0 25 25';
